export default "/images/claritick-platform.svg?20668da41cd9c3234a5d857abcf13dc1";